export function getVisitChangesFromResults(activity, visit, _visitor) {
  var _a, _b, _c;
  var changes = [];
  if (((_a = activity === null || activity === void 0 ? void 0 : activity.visitActivities) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = activity === null || activity === void 0 ? void 0 : activity.visitUpdates) === null || _b === void 0 ? void 0 : _b.length) > 0) {
    changes.push("activities");
  }
  if (((_c = activity === null || activity === void 0 ? void 0 : activity.visitUpdates) === null || _c === void 0 ? void 0 : _c.length) > 0) {
    activity.visitUpdates.forEach(function (update) {
      if (!changes.includes(update.type)) {
        changes.push(update.type);
      }
    });
  }
  var map = new Map();
  map.set(visit.id, changes);
  return map;
}
export function getVisitChangesFromVisits(visits, _visitor) {
  var map = new Map();
  visits === null || visits === void 0 ? void 0 : visits.forEach(function (visit) {
    if (!(visit === null || visit === void 0 ? void 0 : visit.data)) return;
    var changes = [];
    if (Array.isArray(visit.data.activities)) {
      visit.data.activities.forEach(function (activity) {
        if ((activity === null || activity === void 0 ? void 0 : activity.type) && changes.indexOf(activity.type) == -1) {
          changes.push(activity.type);
        }
      });
    }
    if (visit.data.campaign) {
      changes.push("campaign");
    }
    map.set(visit.id, changes);
  });
  return map;
}
export function getVisitorChanges(activity, _visit, _visitor) {
  var _a;
  var changes = [];
  if (((_a = activity === null || activity === void 0 ? void 0 : activity.visitorUpdates) === null || _a === void 0 ? void 0 : _a.length) > 0) {
    activity.visitorUpdates.forEach(function (update) {
      if (!changes.includes(update.type)) {
        changes.push(update.type);
      }
    });
  }
  return changes;
}